const prStyleRegistry = {
    pr_diamond: {
        id: 'pr_diamond',
        name: 'Diamond',
        description: 'Platinum shimmer with ice blue glow',
        icon: '💎',
        containerStyle: {
            background: 'linear-gradient(135deg, #e8e8f0 0%, #b8c0d0 30%, #d8dce8 60%, #a8b4c8 100%)',
            boxShadow: '0 0 25px rgba(180, 200, 230, 0.4)',
        },
        textColor: '#1a1a2e',
        newValueColor: '#0d47a1',
        confettiColors: ['#E0E0E0', '#B0C4DE', '#87CEEB', '#FFFFFF', '#4FC3F7'],
    },
    pr_trophy: {
        id: 'pr_trophy',
        name: 'Trophy',
        description: 'Classic trophy celebration',
        icon: '🏆',
        containerStyle: {
            background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
        },
        textColor: '#f0d060',
        newValueColor: '#66bb6a',
        confettiColors: ['#FFD700', '#C0C0C0', '#CD7F32', '#FFFFFF', '#4169E1'],
    },
    pr_beast_mode: {
        id: 'pr_beast_mode',
        name: 'Beast Mode',
        description: 'Screen shake with bold text',
        icon: '💪',
        containerStyle: {
            background: 'linear-gradient(135deg, #1a0000 0%, #4a0000 50%, #8b0000 100%)',
        },
        textColor: '#ff4444',
        newValueColor: '#69f0ae',
        confettiColors: ['#FF0000', '#FF4500', '#DC143C', '#B22222', '#FF6347'],
        shake: true,
    },
    pr_subtle: {
        id: 'pr_subtle',
        name: 'Subtle Glow',
        description: 'Understated glow effect',
        icon: '✨',
        containerStyle: {
            background: 'linear-gradient(135deg, #f8f8f8 0%, #e8e8e8 100%)',
            boxShadow: '0 0 20px rgba(100, 200, 255, 0.3)',
        },
        textColor: '#333333',
        newValueColor: '#2E7D32',
        confettiColors: ['#87CEEB', '#B0E0E6', '#ADD8E6', '#E0E0E0', '#F0F0F0'],
    },
    pr_neon: {
        id: 'pr_neon',
        name: 'Neon',
        description: 'Electric neon glow',
        icon: '💜',
        containerStyle: {
            background: 'linear-gradient(135deg, #0a0a0a 0%, #1a0a2e 50%, #0a0a0a 100%)',
            boxShadow: '0 0 30px rgba(138, 43, 226, 0.4)',
        },
        textColor: '#00ff88',
        newValueColor: '#00ff88',
        confettiColors: ['#FF00FF', '#00FFFF', '#39FF14', '#FF6EC7', '#7B68EE'],
    },
    pr_midnight: {
        id: 'pr_midnight',
        name: 'Midnight',
        description: 'Deep indigo with silver accents',
        icon: '🌙',
        containerStyle: {
            background: 'linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)',
            boxShadow: '0 0 20px rgba(48, 43, 99, 0.5)',
        },
        textColor: '#e0d8f0',
        newValueColor: '#b8a9e8',
        confettiColors: ['#C0C0C0', '#9B8EC4', '#E8E0F0', '#6C63AC', '#FFFFFF'],
    },
    pr_sakura: {
        id: 'pr_sakura',
        name: 'Sakura',
        description: 'Cherry blossom celebration',
        icon: '🌸',
        containerStyle: {
            background: 'linear-gradient(135deg, #fce4ec 0%, #f8bbd0 40%, #f48fb1 100%)',
            boxShadow: '0 0 20px rgba(244, 143, 177, 0.3)',
        },
        textColor: '#4a0e2a',
        newValueColor: '#880e4f',
        confettiColors: ['#FCE4EC', '#F8BBD0', '#F48FB1', '#EC407A', '#FFFFFF'],
    },
    pr_ember: {
        id: 'pr_ember',
        name: 'Ember',
        description: 'Smoldering warmth with glowing coals',
        icon: '🔶',
        containerStyle: {
            background: 'linear-gradient(135deg, #1a0a00 0%, #3d1c00 40%, #5a2d0c 100%)',
            boxShadow: '0 0 25px rgba(255, 120, 30, 0.3)',
        },
        textColor: '#ffb74d',
        newValueColor: '#ffd54f',
        confettiColors: ['#FF9800', '#FF6D00', '#FFB74D', '#E65100', '#FFC107'],
    },
};

export function getAllPrStyles() {
    return Object.values(prStyleRegistry);
}

export default prStyleRegistry;
